import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {ProductTypeDetails} from "falcon-api";
import {FacadeService} from "../shared/service-facade/facade.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import {BRANCH_PATH, PRODUCT_PATH} from "../shared/constants";
import {CoreService} from "../shared/services/core.service";
import {ThemeService} from "../core/services/theme.service";
import {MainLayoutService} from "../shared/services/main-layout.service";

@Component({
  selector: 'app-banking-center',
  templateUrl: './banking-center.component.html',
  styleUrls: ['./banking-center.component.scss']
})
export class BankingCenterComponent implements OnInit {
  landscapeMediaMatcher = window.matchMedia("(orientation: landscape)");
  isLandscape = false;

  public productTypeDetails : ProductTypeDetails[] = new Array<ProductTypeDetails>();

  constructor(
    private facadeService: FacadeService,
    public domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private changeDetector: ChangeDetectorRef,
    private mainLayout: MainLayoutService
  ) {
    this.isLandscape = this.landscapeMediaMatcher.matches;

    this.landscapeMediaMatcher.addEventListener("change", event => {
      this.isLandscape = this.landscapeMediaMatcher.matches;
      this.changeDetector.detectChanges();
    });
  }

  ngOnInit(): void {
    this.mainLayout.setPageTitle("Select a Product");

    if(!this.facadeService.isFromBranch()) this.coreService.navigate(BRANCH_PATH);

    if(this.route.snapshot.queryParamMap.get('product') !== null) {
      const product = this.route.snapshot.queryParamMap.get('product');

      const path = '/' + PRODUCT_PATH + '?product=' + product + '&bankingCenter=true';

      window.location.href = path;
    } else {
      this.facadeService.getProductTypes().subscribe(value => {
        this.productTypeDetails = value;
      });
    }
  }

  getUrl(url : string) : SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
